import lottie from "lottie-web";

class LoadingLottie {
  constructor(selector = ".js-loading-lottie", options = {}) {
    this.selector = selector;

    this.options = {
      renderer: "svg",
      loop: false,
      autoplay: false, // 自動再生しない
      delay: 1000, // 1秒後
      ...options,
    };

    this.instances = [];

    this.init();
  }

  init() {
    const elements = document.querySelectorAll(this.selector);

    if (!elements.length) return;

    elements.forEach((element) => {
      const path = element.dataset.lottiePath;

      if (!path) return;

      const instance = lottie.loadAnimation({
        container: element,
        renderer: this.options.renderer,
        loop: this.options.loop,
        autoplay: false,
        path,
      });

      // 念のため初期フレームで止める
      instance.goToAndStop(0, true);

      window.setTimeout(() => {
        instance.play();
      }, this.options.delay);

      this.instances.push(instance);
    });
  }

  destroy() {
    if (!this.instances.length) return;

    this.instances.forEach((instance) => {
      if (instance && typeof instance.destroy === "function") {
        instance.destroy();
      }
    });

    this.instances = [];
  }
}

export default LoadingLottie;
